import  Picto,{pictoProps, pictoState} from "./Picto";
import {connect} from "react-redux";

export interface OfflinePictoProps extends pictoProps {
}

export interface OfflinePictoState extends pictoState {
}

export class OfflinePicto extends Picto<OfflinePictoProps,OfflinePictoState>{
    constructor(props) {
        super(props);
        this.picto = this.props.theme.pictos.offlinePicto;
    }
}

const mapStateToProps = (state) => {
    return {isDark: state.changeTheme.isDark,theme: state.changeTheme.theme};
}

export default connect(mapStateToProps)(OfflinePicto);

